// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","localsMenu":"_3yTxN","locale":"_1jkIy","link":"_2sXAG","active":"_19cie"};